'use client';

import Image from 'next/image'
import React from 'react'
import aboutimg from "../../../assets/Image/home-img/common/about-img.png";
import rightarrow from "../../../assets/Image/comman/rightarrow.svg"
import { useRouter } from 'next/navigation';


export const AboutUs = () => {
  const router = useRouter();

  return (
    <div className='container flex flex-col lg:flex-row items-center gap-11 justify-center overflow-hidden'>
      <Image src={aboutimg} alt='aboutimg' className='w-full lg:w-[40%] ' data-aos="fade-right" />
      <div data-aos="fade-left">
        <div className='flex  gap-6'>
          <h6>ABOUT US</h6>

          <Image src={rightarrow} alt='left arrow' />

        </div>
        <div className='flex flex-col gap-2.5'>
          <h2 className='font-bold max-w-[35rem]  pt-3' >Your Trusted Partner in Unforgettable Travel</h2>
          <p className='text-dark-gray max-w-[40rem] font-medium'>
            At MS Tourism, we believe that travel is more than just visiting places&#8212;it&#39;s about experiencing new cultures, making lifelong memories, and enjoying a stress-free journey. Whether you seek luxury, adventure, or budget-friendly escapes, our expert team ensures a seamless travel experience tailored just for you.
          </p>

          <p className='text-dark-gray max-w-[40rem] font-medium'>With years of experience, strong global connections, and a passion for travel, we take care of every detail—so you can focus on enjoying your journey. From flight bookings to curated experiences, we make travel effortless and unforgettable.</p>
          <button className='btn w-fit' onClick={() => router.push("/about")} >About Us</button>
        </div></div>
    </div>
  )
}
